export default {
    IMAGE : 1,
    DOCUMENT : 2,
    CONTRACT : 3,
}